module.exports = __webpack_public_path__ + "static/media/28DGC1.5ff3250a.jpg";